import PropTypes from 'prop-types';
import React from 'react';
import { AutocompleteArrayInput as ReactAdminAutocompleteArrayInput, required as requiredFn } from 'react-admin';

export const AutocompleteArrayInput = ({ isRequired, validate, ...props }) => (
  <ReactAdminAutocompleteArrayInput
    {...props}
    validate={isRequired ? requiredFn() : validate}
  />
)

AutocompleteArrayInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  validate: PropTypes.func,
};

AutocompleteArrayInput.defaultProps = {
  sort: false,
  sortable: false,
  alwaysOn: true
};

export default AutocompleteArrayInput;

